import React, { useState, useEffect } from 'react';
import Auth from './Auth';
import Dashboard from './Dashboard';
import './index.css';

function App() {
  // Use session storage to keep auth state during reloads for convenience, 
  // though real auth would require a backend.
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('salesPortalAuth') === 'true';
  });

  const handleLogin = () => {
    setIsAuthenticated(true);
    sessionStorage.setItem('salesPortalAuth', 'true');
  };

  if (!isAuthenticated) {
    return <Auth onLogin={handleLogin} />;
  }

  return <Dashboard />;
}

export default App;